import { ListBoxItemProps } from "react-aria-components";
import { ReactNode } from "react";

export interface MDSListBoxItemProps extends Omit<ListBoxItemProps, "children"> {
  children?: ReactNode;
  leftAddon?: ReactNode;
  rightAddon?: ReactNode;
}

// Add enum for slots
export enum MDSListBoxSlotName {
  LeftAddon = "left-addon",
  RightAddon = "right-addon",
}
